import { useEffect } from 'react';
import logger from '../../core/logger/logger';

/**
 * Хук для логирования рендеров компонентов (только в development режиме)
 * 
 * Используется для отладки, чтобы видеть, когда компонент рендерится
 */
export const useRenderLogger = (componentName, data = {}) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      logger.debug(`${componentName} rendered`, data);
    }
  });
};

